import script from "./Features.vue?vue&type=script&setup=true&lang=js"
export * from "./Features.vue?vue&type=script&setup=true&lang=js"

import "./Features.vue?vue&type=style&index=0&id=1f099c88&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f099c88"]])

export default __exports__